import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import * as API from "../../../api";
import * as CONST from "../../../Constants";
import FormPaper from "../../../layout/FormPaper";
import FieldWrapper from "../../../layout/FieldWrapper";
import PromptButtons from "./PromptButtons";
import { PatientData } from "../../../Contexts";

const propTypes = {
  cpr: PropTypes.object.isRequired,
  handleUpdated: PropTypes.function,
  dispatch: PropTypes.func.isRequired,
  handleFlash: PropTypes.func,
};
ConfirmationPrompt.prototype = propTypes;

export default function ConfirmationPrompt(props) {
  const patient = useContext(PatientData);
  const [requestedOrder, setRequestedOrder] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleSuccess(confirmRes) {
    props.handleFlash({
      success: requestedOrder
        ? CONST.FLASH.ORDER_REQUESTED
        : props.cpr.status == "reminder"
        ? CONST.FLASH.REMINDER_CONFIRMED
        : !confirmRes.data.cpr.appointment_date
        ? CONST.FLASH.DUE_DATE_CONFIRMED
        : CONST.FLASH.APPOINTMENT_CONFIRMED,
    });

    props.dispatch(confirmRes.data.cpr);
    props.handleUpdated();
  };

  async function handleConfirm() {
    !loading && setLoading(true);
    let confirmRes = await API.postCprStatus({
      notification_id: props.cpr.current_notification_id,
      cpr_id: props.cpr.id,
      option_value: 1, //I am aware of this care plan requirement
    });
    if (confirmRes.data.cpr) {
      handleSuccess(confirmRes);
    } else {
      props.handleFlash({
        error: CONST.FLASH.ERROR,
      });
    }
    setTimeout(() => setLoading(false), 300);
  }

  async function handleRequestedOrder() {
    !loading && setLoading(true);
    setRequestedOrder(true);
    let res = await API.postCprStatus({
      notification_id:  props.cpr.current_notification_id,
      cpr_id: props.cpr.id,
      option_value: 6, //Request Order
    });

    if (res.data.cpr) {
      handleSuccess(res);
    }
  }

  const renderLoading = (
    <div className="text-center">
      <i className="fa fa-spinner fa-spin fa-load-page"></i>
      <br />
      Submitting..
    </div>
  );

  const renderConfirmButton = (
    <Box mt={2}>
      {!loading ? (
        <button
          className="prompt confirm"
          onClick={(e) => {
            handleConfirm();
          }}
        >
          {"Ok! "}
        </button>
      ) : (
        renderLoading
      )}
    </Box>
  );

  const renderOutOfArea = (
    <>
      <Typography variant="body2" mt={1}>
        {props.cpr.primary_code
          ? CONST.OOA.CONFIRM_PRIMARY
          : CONST.OOA.CONFIRM_NON_PRIMARY_ORDER_ACKNOWLEDGEMENT}
      </Typography>
      {renderConfirmButton}
    </>
  );
  const renderInArea = (
    <>
      {props.cpr.primary_code ? (
        <>
          <Typography variant="body2" mt={1}>
            {CONST.CALL_CENTER_TEXT_FOR_PRIMARY_CODE(patient.vip_number)}
          </Typography>
          {renderConfirmButton}
        </>
      ) : (
        <>
          {!props.cpr.order_not_available_reason && !props.cpr.patient_requested_order && !(props.cpr.order_document && props.cpr.order_document.url) && (
            <PromptButtons
              promptText={CONST.ORDER_REQUEST_PROMPT}
              buttons={{
                yesText: "Yes",
                noText: "No",
                onSelect: (val) => {
                  if (val == "yes") {
                    handleRequestedOrder();
                  } else {
                    handleConfirm();
                  }
                },
              }}
              children={
                <Typography variant="body2" mt={1}>
                  {CONST.ORDER_REQUEST_PROMPT_CALL_CENTER_TEXT(patient.vip_number)}
                </Typography>
              }
            />
          )}
          {(props.cpr.order_not_available_reason != null || props.cpr.patient_requested_order ||
            (props.cpr.order_document && props.cpr.order_document.url)) && (
              <FieldWrapper
                title={CONST.NO_APPOINTMENT_SCHEDULED_WITH_ORDER_TEXT}
                children={
                  <>
                    <Typography variant="body2" mt={1}>
                      {CONST.CALL_CENTER_TEXT(patient.vip_number)}
                    </Typography>

                    {renderConfirmButton}
                  </>
                }
              />
            )}
        </>
      )}
    </>
  );
  return (
    <FormPaper>
      {loading ? renderLoading : <>{patient.out_of_area ? renderOutOfArea : renderInArea}</>}
    </FormPaper>
  );
}
